import clsx from "clsx";
import { useState, useRef, useLayoutEffect, ReactNode } from "react";
import { Icon, RenderWhen } from "../../../../components";
import styles from "./ioc.module.scss";

interface ExpandableValueProps {
  value?: string | ReactNode;
  fallback?: ReactNode;
}

const ExpandableValue = ({ value, fallback }: ExpandableValueProps) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [hasOverflow, setHasOverflow] = useState(false);
  const textRef = useRef<HTMLSpanElement>(null);

  useLayoutEffect(() => {
    const el = textRef.current;
    if (el) {
      const checkOverflow = () => {
        const isOverflowing = el.scrollWidth > el.clientWidth + 1;
        setHasOverflow(isOverflowing);
      };

      checkOverflow();
      const observer = new ResizeObserver(checkOverflow);
      observer.observe(el);

      return () => observer.disconnect();
    }
    return undefined;
  }, [value]);

  if (!value) {
    return <>{fallback}</>;
  }

  return (
    <span
      className={clsx(
        styles.line_clamp_container,
        isExpanded && styles.expanded
      )}
    >
      <span ref={textRef} className={clsx(!isExpanded && styles.line_clamp)}>
        {value}
      </span>
      <RenderWhen condition={hasOverflow || isExpanded}>
        <span
          className="inline-flex align-items-center cursor-pointer white-space-nowrap m-left-2"
          onClick={() => setIsExpanded(prev => !prev)}
        >
          <span className="underline">
            {isExpanded ? "Show Less" : "Show More"}
          </span>
          <Icon
            name={isExpanded ? "chevron-up" : "chevron-down"}
            className="vertical-align-middle m-left-2"
          />
        </span>
      </RenderWhen>
    </span>
  );
};

export default ExpandableValue;
